/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Notnow1Inputs */

const en_feedback_notnow1 = /** @type {(inputs: Feedback_Notnow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not now`)
};

/**
* | output |
* | --- |
* | "Not now" |
*
* @param {Feedback_Notnow1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const feedback_notnow1 = /** @type {((inputs?: Feedback_Notnow1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Notnow1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_feedback_notnow1(inputs)
});
export { feedback_notnow1 as "feedback_notNow" }